// extracted by mini-css-extract-plugin
module.exports = {"container":"linkRecommended_container__6YUV2","header":"linkRecommended_header__jzwag","itemHeader":"linkRecommended_itemHeader__Osqmi","item":"linkRecommended_item__hf7TU"};